export default "__VITE_ASSET__6PbcPncC__"